<template>
  <div>
    <transition name="slide-fade" mode="out-in">
        <div class="row mt-3">
          <div class="col">
            <h3>Прикреплённые документы</h3>
            <div class="group">
              <PassportUpload v-if="false" commentPosition="before" />
              <RequestScanUpload commentPosition="before" />
            </div>
          </div>
        </div>
    </transition>
  </div>
</template>

<script>
import PassportUpload from './passportUpload.vue'
import RequestScanUpload from './requestScanUpload.vue'

export default {
  components: {
    PassportUpload,
    RequestScanUpload
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped>
  .group {
    border-left: 5px groove rgba(0, 174, 255, 0.959);
    padding-left: 10px;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
